//Compair and Pair Scroll Button
(() => {
    // const scrollAmount = 200;

    function updateComparePairButtonVisibility(container, btnGroup, btnLeft, btnRight) {

        const isScrollable = container.scrollWidth > container.clientWidth;

        if(!isScrollable){
            btnGroup.style.display = "none";
            return
        } else {
            btnGroup.style.display = "flex";
        }

        const currentScroll = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        btnLeft.style.opacity = currentScroll > 5 ? '1' : '0.5';
        btnLeft.style.pointerEvents = currentScroll > 5 ? 'auto' : 'none';

        btnRight.style.opacity = currentScroll < maxScroll - 5 ? '1' : '0.5';
        btnRight.style.pointerEvents = currentScroll < maxScroll - 5 ? 'auto' : 'none';
    }

    function comparePairButtons(root = document){
        const container = root.querySelector('.compare-pair_table-wrap');
        const btnGroup = root.querySelector('.compare-pair_button-group');
        const btnLeft = root.getElementById('compare-pair_scroll-left');
        const btnRight = root.getElementById('compare-pair_scroll-right');

        if(!container || !btnGroup || !btnLeft || !btnRight) return;

        // to get "td" width
        const getScrollStep = () => {
            const firstCell = container.querySelector('td');
            return firstCell ? firstCell.offsetWidth : 200;
        };

        btnLeft.replaceWith(btnLeft.cloneNode(true));
        btnRight.replaceWith(btnRight.cloneNode(true));

        const newBtnLeft = root.getElementById('compare-pair_scroll-left');
        const newBtnRight = root.getElementById('compare-pair_scroll-right');

        newBtnLeft.addEventListener('click', () => {
            const currentScroll = container.scrollLeft;
            const step = getScrollStep();
            const isMobile = window.innerWidth <= 676;
            
            if (isMobile && currentScroll < 100) {
                container.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                container.scrollBy({ left: -step, behavior: 'smooth' });
            }
        });

        newBtnRight.addEventListener('click', () => {
            const currentScroll = container.scrollLeft;
            const step = getScrollStep();
            const isMobile = window.innerWidth <= 676;

            if (isMobile && currentScroll < 5) {
                container.scrollTo({ left: 90, behavior: 'smooth' });
            } else {
                container.scrollBy({ left: step, behavior: 'smooth' });
            }
        });

        container.addEventListener('scroll', () => {
            updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight)
        });

        window.addEventListener('resize', () => {
            updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight)
        });

        updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight);
    }

    document.addEventListener("DOMContentLoaded", () => {
        comparePairButtons(document);
    });

    document.addEventListener("shopify:section:load", (e) => {
        comparePairButtons(e.target);
    });

    document.addEventListener("shopify:section:select", (e) => {
        comparePairButtons(e.target);
    });

    document.addEventListener("shopify:section:reorder", () => {
        comparePairButtons(document);
    });
})();


// Good To Know Expand Button
document.addEventListener("DOMContentLoaded", function () {
  let tabTrigger = '.tab-expend-btn'
  
  let tabClasses = {
    hide: 'hide',
    open: 'tab-is-open',
    autoHeight: 'tab--auto-height'
  }

  document.querySelectorAll(tabTrigger).forEach(function (btn){
    btn.addEventListener('click',function(evt){
      
      let el = evt.currentTarget
      let isOpen = el.classList.contains(tabClasses.open)
      let moduleId = el.getAttribute('aria-controls')
      let container = document.getElementById(moduleId)

      let fullHeight = container.scrollHeight + 'px';
    
      if (!moduleId) {
        moduleId = el.dataset.controls
      }
    
      if (!moduleId) {
        return
      }

      if (isOpen) {
        el.classList.remove(tabClasses.open),
        container.classList.remove(tabClasses.open),
        container.style.height = '650px',
        btn.style.setProperty('--before-content', '"View More"');

        setTimeout(() => {
          const offset = 70;
          const elementPosition = btn.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - window.innerHeight + btn.offsetHeight + offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 10);

      } else {
        el.classList.add(tabClasses.open),
        container.classList.add(tabClasses.open),
        container.style.height = fullHeight,
        btn.style.setProperty('--before-content', '"View Less"');
      }
      
    });
  });
});